import { render, staticRenderFns } from "./SignUpView.vue?vue&type=template&id=71a14df3&"
import script from "./SignUpView.vue?vue&type=script&lang=js&"
export * from "./SignUpView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports